import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["variant", "inlineSize", "borderRadius", "blockSize"];
import { LayoutBox } from '../Layout/LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
const backgroundMap = {
  breeze: 'background-color-breeze',
  'breeze-dark': 'gradient-breeze-dark',
  'breeze-light': 'gradient-breeze-light',
  default: 'background-color',
  light: 'background-color-light',
  dark: 'background-color-dark'
};
export const Placeholder = _ref => {
  let {
      variant = 'default',
      inlineSize = '100%',
      borderRadius = 'border-radius-md',
      blockSize = '0.625rem'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const background = backgroundMap[variant];
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
    background: background,
    blockSize: blockSize,
    borderRadius: borderRadius,
    inlineSize: inlineSize
  }));
};